import { FiEdit } from "react-icons/fi";
import { LuTrash2 } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import { tBodyItemStyle } from "../users/UserListItem";
import { useDispatch } from "react-redux";
import { modalActions } from "../../store/modalSlice";
import { useDeleteBlogMutation } from "../../store/services/blogServices";
import ReactModal from "../ReactModal";
import { useState } from "react";
import { CiImageOff } from "react-icons/ci";

const removeHtmlTags = (html) => {
    if (!html) return "";
    return html.replace(/<\/?[^>]+(>|$)/g, "")
}

// Mobile Card Component
export function BlogListItemMobile({ blog }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    const handleCardClick = () => {
        navigate(`/blogs/${blog.blog_id}/edit`);
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        dispatch(modalActions.openModal({ details: { id: blog.blog_id, name: blog.title, category: 'blog' } }));
    };

    return (
        <div
            className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-3 cursor-pointer active:bg-gray-50 dark:active:bg-gray-700"
            onClick={handleCardClick}
        >
            {/* Top section: Image + Info */}
            <div className="flex gap-3">
                {/* Image */}
                <div className="relative rounded-lg w-20 h-16 overflow-hidden flex-shrink-0 bg-gray-100 dark:bg-gray-700">
                    {blog.image_path ? (
                        <>
                            {!isImageLoaded && (
                                <div className="absolute inset-0 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 animate-pulse" />
                            )}
                            <img
                                src={`https://api.pronascout.com/${blog.image_path}`}
                                alt=""
                                className={`w-full h-full object-cover transition-opacity duration-300 ${isImageLoaded ? 'opacity-100' : 'opacity-0'}`}
                                onLoad={() => setIsImageLoaded(true)}
                            />
                        </>
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-gray-400">
                            <CiImageOff size={20} />
                        </div>
                    )}
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 line-clamp-2">{blog.title}</h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 line-clamp-2">
                        {removeHtmlTags(blog.text)}
                    </p>
                </div>
            </div>

            {/* Bottom section: Actions */}
            <div className="flex justify-end items-center mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
                <div className="flex gap-2">
                    <button
                        className="w-8 h-8 rounded-full bg-primary flex items-center justify-center"
                        title="Edit"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FiEdit size={14} />
                    </button>
                    <button
                        className="w-8 h-8 rounded-full bg-primary flex items-center justify-center"
                        title="Delete"
                        onClick={handleDeleteClick}
                    >
                        <LuTrash2 size={14} />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function BlogListItem({ blog }) {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [deleteBlog, { isLoading, isSuccess, isError }] = useDeleteBlogMutation()

    const handleBlogDelete = (e) => {
        e.stopPropagation();
        dispatch(modalActions.openModal({ details: { id: blog.blog_id, name: blog.title, category: 'blog' } }))
    }

        const handleRowClick = () => {
            navigate(`/blogs/${blog.blog_id}/edit`);
          };   

    return (
        <>
            <tr className="table_row" onClick={handleRowClick}>
                <td style={tBodyItemStyle} className="text-black dark:text-gray-100 font-medium w-1/4"><span className="line-clamp-2">{blog.title}</span></td>
                <td style={tBodyItemStyle} className="w-1/3 dark:text-gray-300">{removeHtmlTags(blog.text).length > 30 ? `${removeHtmlTags(blog.text).split(" ").slice(0, 8).join(" ")}...` : removeHtmlTags(blog.text)}</td>
                <td style={{ ...tBodyItemStyle, padding: '0px 20px', }} className="">
                    <div className="w-[100px] h-[50px]">
                        <img src={`https://api.pronascout.com/${blog.image_path}`} alt="blog_img" className="w-full h-full object-cover rounded-xl" />
                    </div>
                </td>
                <td style={tBodyItemStyle}>
                    <div className="flex justify-center gap-4">
                        <Link to={`/blogs/${blog.id}/edit`}>
                            <div className="rounded-full w-8 h-8 text-center bg-primary relative cursor-pointer actions">
                                <FiEdit style={{ fontSize: '14px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                            </div>
                        </Link>
                        <div className="rounded-full w-8 h-8 flex justify-center items-center text-center bg-primary relative cursor-pointer actions" onClick={handleBlogDelete}>
                            <LuTrash2 style={{ fontSize: '16px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                        </div>
                    </div>
                </td>
            </tr>
        </>
    )
}